import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';

import type { SpaceAdapter } from '@toolproof-core/visualization/adapter/_contract/adapter';

import { CONFIG } from '@/adapters/primitive/_data/config/config';
import { buildCosmosData } from '@/adapters/primitive/_pure/cosmosData';
import { getResourceTypeInputSpec } from '@/adapters/primitive/_pure/resourceTypeInputSpec';
import { episodePresentation } from '@/adapters/primitive/episodePresentation';
import { createSpaceDeriver } from '@/adapters/primitive/framePipeline';
import { createRuntimeEffectOwner, runtimeController } from '@/adapters/primitive/runtime';
import { SPACE_KEY } from '@/adapters/primitive/spaceIdentity';
import type { SpaceAdapterDescriptor } from '@/_contract/types';
import type { Config, CosmosDataModel, RuntimeState } from '@/adapters/primitive/_contract/config';

export const spaceAdapter: SpaceAdapter<
    ResourceTypeHandle,
    CosmosDataModel,
    Config,
    RuntimeState
> = {
    createSpaceDeriver,
};

export const DESCRIPTOR = {
    episodePresentation,
    createRuntimeEffectOwner,
    baseDescriptor: {
        spaceKey: SPACE_KEY,
        adapter: spaceAdapter,
        getResourceTypeInputSpec,
        buildCosmosData,
        defaultConfig: CONFIG,
    },
    runtime: {
        kind: 'single',
        controller: runtimeController,
    },
} as const satisfies SpaceAdapterDescriptor<
    ResourceTypeHandle,
    CosmosDataModel,
    Config,
    RuntimeState
>;

export type AdapterDescriptor = typeof DESCRIPTOR;
